import React, {Component} from 'react';
import Logo from "../../static/img/mp-logo.jpg";
import "./NavsMp.scss"

class NavsMp extends Component {
    render() {
        return (
            <div
                className={`home-nav-mp`}>
                <div className="home-content" >
                    <div className="home-logo" >
                        <img src={Logo} alt=""/>
                    </div>
                </div>
            </div>
        );
    }
}

export default NavsMp;
